/**
 * This file contains all the dependancies library needed
 * 
 * It is used for the library that we don't wish to include in webpack compilation
 */

var CDN_URL = "https://cdn.rawgit.com/aetna-softwares" ;
var VERSIONS = {
    view : "8beee9d27163fd828897f9631f393f72887ef880",
    loader: "c53d798e",
    controller: "82d7b847235fb72dd83150dd3ea41ceca2f1c68b"
} ;

module.exports = [
    { name: "velox-web-view",
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/velox-web-view.js",
        localPath: "velox/view/velox-web-view.js"
    },
    [
        { name: "velox-web-view-ext-i18n", 
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-i18next.js",
            localPath: "velox/view/ext/velox-i18next.js"
        },
        { name: "velox-web-view-ext-bootstrap4-dialogs",
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-bootstrap4-dialogs.js",
            localPath: "velox/view/ext/velox-bootstrap4-dialogs.js"
        },
        { name: "velox-web-view-ext-fields",
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-fields.js",
            localPath: "velox/view/ext/velox-fields.js"
        },
        { name: "velox-web-view-ext-charts",
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-charts.js",
            localPath: "velox/view/ext/velox-charts.js"
        },
        { name: "velox-web-view-ext-fields-schema",
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-fields-schema.js",
            localPath: "velox/view/ext/velox-fields-schema.js"
        },
        // { name: "velox-web-view-ext-list", //Use if you need list input (like invoice lines)
        //     type: "js",
        //     version: "0.0.1",
        //     cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-list.js",
        //     npmPath: "velox-view/ext/velox-list.js"
        // },
        { name: "velox-web-view-ext-user-rights", //Use if you need some user right managment in views
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-view/master/ext/velox-user-rights.js",
            localPath: "velox/view/ext/velox-user-rights.js"
        }
    ],
    [
        { name: "velox-controller",
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-app-controller.js",
            localPath: "velox/controller/velox-app-controller.js"
        },
        { name: "velox-controller-view",
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-view-controller.js",
            localPath: "velox/controller/velox-view-controller.js"
        }
    ],
    [
        { name: "velox-controller-grid", //Use if you need a grid screen
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-form-controller.js",
            localPath: "velox/controller/velox-form-controller.js"
        },
        {  name: "velox-controller-form", //Use if you need a form screen
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-grid-controller.js",
            localPath: "velox/controller/velox-grid-controller.js"
        }
    ],
    [
        {  name: "velox-controller-importer", //Use if you need an importer
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-importer-controller.js",
            localPath: "velox/controller/velox-importer-controller.js"
        }
    ],
    [
        { name: "velox-controller-grid-and-form", //Use if you need a CRUD grid+form screens
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-grid-and-form-controller.js",
            localPath: "velox/controller/velox-grid-and-form-controller.js"
        }
    ],
    [
        { name: "velox-controller-grid-form-importner", //Use if you need a CRUD grid+form+importer screens
            type: "js",
            version: VERSIONS.controller,
            cdn: CDN_URL+"/velox-controller/$VERSION/velox-grid-form-importer-controller.js",
            localPath: "velox/controller/velox-grid-form-importer-controller.js"
        }
    ],
    { name: "velox-service-client", //Use if you need to talk to a server
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-service-client/master/velox-service-client.js",
        localPath: "velox/service-client/VeloxServiceClient.js"
    },
    { name: "velox-database-client", //Use if you server part use database
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/VeloxDatabaseClient.js",
        localPath: "velox/database-client/client/src/VeloxDatabaseClient.js"
    },
    { name: "velox-offlinesync-client", //Use if you need offline sync
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/ext/VeloxDbOfflineSync.js",
        localPath: "velox/database-client/client/src/ext/VeloxDbOfflineSync.js"
    },
    { name: "velox-offlinesync-loki", //Use if you need offline sync
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/ext/VeloxDbOfflineLoki.js",
        localPath: "velox/database-client/client/src/ext/VeloxDbOfflineLoki.js"
    },
    { name: "velox-usermanagment-client", //Use if you manage user rights
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/VeloxUserManagmentClient.js",
        localPath: "velox/database-client/client/src/VeloxUserManagmentClient.js"
    },
    { name: "velox-crashreport-client", //Use if you need crash reports
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/VeloxCrashReportClient.js",
        localPath: "velox/database-client/client/src/VeloxCrashReportClient.js"
    },
    { name: "velox-binarystorage-client", //Use if you need some binary attachments
        type: "js",
        version: "0.0.1",
        cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/VeloxBinaryStorageClient.js",
        localPath: "velox/database-client/client/src/VeloxBinaryStorageClient.js"
    },
    [
        { name: "velox-binaryoffline-client", //Use if you need binary offline
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/ext/VeloxBinaryOfflineSyncClient.js",
            localPath: "velox/database-client/client/src/ext/VeloxBinaryOfflineSyncClient.js"
        }
    ],
    // [
    //     {
    //         name: "lie-polyfill",
    //         type: "js",
    //         version: "3.3.0",
    //         cdn: "https://cdnjs.cloudflare.com/ajax/libs/lie/$VERSION/lie.polyfill.min.js",
    //         bowerPath: "lie/dist/lie.polyfill.min.js",
    //         npmPath: "lie/dist/lie.polyfill.min.js"
    //     },
    // ],
    // [
    //     { name: "velox-binaryoffline-forage", //Binary offline in browser
    //         type: "js",
    //         version: "0.0.1",
    //         cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/ext/VeloxBinaryOfflineForage.js",
    //         npmPath: "velox-database-client/client/src/ext/VeloxBinaryOfflineForage.js"
    //     },
    //     {
    //         name: "localforage",
    //         type: "js",
    //         version: "1.7.2",
    //         cdn: "https://cdnjs.cloudflare.com/ajax/libs/localforage/$VERSION/localforage.nopromises.min.js",
    //         bowerPath: "localforage/dist/localforage.nopromises.min.js",
    //         npmPath: "localforage/dist/localforage.nopromises.min.js"
    //     }
    // ],
    [
        { name: "velox-binaryoffline-cordova", //Binary offline in mobile
            type: "js",
            version: "0.0.1",
            cdn: "https://cdn.rawgit.com/aetna-softwares/velox-database-client/master/client/src/ext/VeloxBinaryOfflineCordova.js",
            localPath: "velox/database-client/client/src/ext/VeloxBinaryOfflineCordova.js"
        }
    ],
    [
        {
            name: "lokijs",
            type: "js",
            version: "1.5.5",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/lokijs/$VERSION/lokijs.min.js",
            bowerPath: "lokijs/build/lokijs.min.js",
            npmPath: "lokijs/build/lokijs.min.js"
        },
        {
            name: "lokijs-indexed-adapter",
            type: "js",
            version: "1.5.5",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/lokijs/$VERSION/loki-indexed-adapter.min.js",
            bowerPath: "lokijs/build/loki-indexed-adapter.min.js",
            npmPath: "lokijs/build/loki-indexed-adapter.min.js"
        },
        { name: "moment", //Date manipulation
            type: "js",
            version: "2.22.1",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/moment.js/$VERSION/moment.js",
            npmPath: "moment/min/moment-with-locales.min.js"
        }
    ],
    [
        { name: "jquery", //bootstrap 4 dep
            type: "js",
            version: "3.4.1",
            cdn: "http://code.jquery.com/jquery-$VERSION.min.js",
            npmPath: "jquery/dist/jquery.min.js"
        },
        { name: "popper.js",  //bootstrap 4 dep
            type: "js",
            version: "1.14.3",
            cdn: "hhttps://cdnjs.cloudflare.com/ajax/libs/popper.js/$VERSION/umd/popper.min.js",
            npmPath: "popper.js/dist/umd/popper.min.js"
        }
    ],
    [
        {name: "bootstrap-css", //bootstrap 4
            type: "css",
            version: "4.1.1",
            cdn: "https://maxcdn.bootstrapcdn.com/bootstrap/$VERSION/css/bootstrap.min.css",
            npmPath : "bootstrap/dist/css/bootstrap.min.css"
        },
        {name: "bootstrap-js", //bootstrap 4
            type: "js",
            version: "4.1.1",
            cdn: "https://maxcdn.bootstrapcdn.com/bootstrap/$VERSION/js/bootstrap.min.js",
            npmPath : "bootstrap/dist/js/bootstrap.min.js"
        },
        {name: "fontawesome", //icons fontawesome
            type: "css",
            version: "5.0.12",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/$VERSION/css/font-awesome.min.css",
            npmPath : "@fortawesome/fontawesome-free-webfonts/css/fontawesome.css"
        },
        {name: "fontawesome-solid", //icons fontawesome
            type: "css",
            version: "5.0.12",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/$VERSION/css/fa-solid.css",
            npmPath : "@fortawesome/fontawesome-free-webfonts/css/fa-solid.css"
        },
        {name: "fontawesome-brands", //icons fontawesome
            type: "css",
            version: "5.0.12",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/$VERSION/css/fa-brands.css",
            npmPath : "@fortawesome/fontawesome-free-webfonts/css/fa-brands.css"
        },
        {name: "fontawesome-regular", //icons fontawesome
            type: "css",
            version: "5.0.12",
            cdn: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/$VERSION/css/fa-regular.css",
            npmPath : "@fortawesome/fontawesome-free-webfonts/css/fa-regular.css"
        },
        {name : "animated-css", 
            type: "css",
            version: "3.6.1",
            npmPath : "animate.css/animate.min.css"
        },
        {name : "xlsx", //import XLS files 
            type: "js",
            version: "0.13.2",
            npmPath : "xlsx/dist/xlsx.full.min.js"
        },
    ],
    [
        {name: "bootstrap-notify", 
            type: "js",
            version: "3.1.3",
            npmPath : "bootstrap-notify/bootstrap-notify.min.js"
        },
    ],
    [
        {name: "bootstrap-theme",
            type: "css",
            version: "1.0.0",
            localPath: "css/theme.css",
        },
        {name: "domain-theme",
            type: "css",
            version: "1.0.0",
            localPath: "/api/public/getDomainCss",
        },
        {name: "flags-css",
            type: "css",
            version: "3.0.0",
            npmPath : "flag-icon-css/css/flag-icon.min.css"
        },
    ]
] ;